<template>
    <div>
        <modal-crear-editar :configuracion="configuracion_modal" @realizado="restablecer_inputs"></modal-crear-editar>
        <tablita @cargar="cargar($event)" @cargar_url="cargar_url($event)" @nuevo="crear" @editar="editar($event)" :configuracion="configuracion_tabla"></tablita>
    </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import ModalCrearEditar from '../../components/Modal/ModalEditarCrear'
import Tabla from '../../components/Tabla/Tabla'
//import lenguaje from '../../config/es_datatable.json'
export default {
    data:()=>({
        filter:'',
        columnas:[
          {key:'fecha_ingreso',label:'Fecha Ingreso',busqueda:'',tipo:'datetime',searchable:false,path:'fecha_ingreso'},
          {key:'cantidad_litros',label:'Cantidad Litros',busqueda:'',tipo:'number',searchable:true,path:'cantidad_litros'},
          {key:'precio_litro',label:'Precio x Litro',busqueda:'',tipo:'number',searchable:true,path:'precio_litro'},
          {key:'nro_factura',label:'N° Factura',busqueda:'',tipo:'number',searchable:true,path:'nro_factura'},
          {key:'empresas_id',label:'Proveedor',busqueda:'',tipo:'select-loadable',ruta:'/empresas',parametro:'nombre',append_parametro:'&tipo_empresa_ids=5',searchable:true,path:'empresa_texto',opciones:[],valor_opcion:'id',label_opcion:'nombre'},
        ],
        botones:[
          {label:'Editar',clase:'btn-warning',evento:'editar',icono:'fa fa-pen'}
        ],
        lista:[],
        links:[],
        inputs:[
          {cols:4,tipo:'datetimepicker',key:'fecha_ingreso',valor:'',label:'Fecha Ingreso (*)',disabled:false},
          {cols:4,tipo:'numero',key:'cantidad_litros',valor:'',label:'Cantidad Litros (*)',disabled:false},
          {cols:4,tipo:'numero',key:'precio_litro',valor:'',label:'Precio x Litro (*)',disabled:false},
          {cols:4,tipo:'numero',key:'nro_factura',valor:'',label:'N° Factura',disabled:false},
          {cols:4,tipo:'select-loadable',key:'empresas_id',valor:'',label:'Proveedor',busqueda:'',ruta:'/empresas',parametro:'nombre',append_parametro:'&tipo_empresa_ids=5',disabled:false,opciones:[],valor_opcion:'id',label_opcion:'nombre'}
        ],
        configuracion_modal:{
          titulo:'Registrar Ingreso de Petróleo',
          ancho:'xl',
          ruta:'/ingresos_petroleo',
          tipo_ruta:'post',
          titulo_boton:'Crear',
          clase_boton:'btn-success'
        },
        configuracion_tabla:{
          titulo:'Listado de Ingresos de Petróleo',
          titulo_boton:'Nuevo Ingreso de Petróleo',
          clase_boton:'btn-primary',
          btn_nuevo:true
        },
        pagina_actual:''
        /* columns: [
            {label: 'Rut', field: 'rut'},
            {label: 'Nombre', field: 'nombre', headerClass: 'class-in-header second-class'}
        ], */
    }),
    mounted() {
        /* $('#empresas').DataTable({
            language: lenguaje
        }); */
        this.$emit('spinner',true);
        this.cargar_empresas();
    },
    methods: {
        async cargar_empresas(){
          await this.axios.get(`${this.api}/empresas?tipo_empresa_ids=5&limit=99999999`,this.cabeceras_json).then((res)=>{
              this.$set(this.columnas[4],'opciones',res.data.data.data);
              this.$set(this.inputs[4],'opciones',res.data.data.data);
              }).catch(e=>{
                  //alert(e);
              })
              this.cargar('')
        },
        async cargar($event){
          this.$emit('spinner',true);
          this.pagina_actual = `${this.api}/ingresos_petroleo${$event}`;
          this.lista = [];
            await this.axios.get(`${this.api}/ingresos_petroleo${$event}`,this.cabeceras_json).then((res)=>{
                this.lista = res.data.data.data;
                this.links = res.data.data.links;
                this.inicializar_tabla({
                  columnas:this.columnas,
                  lista:this.lista,
                  links:this.links,
                  botones:this.botones
                });
                this.$emit('generar',this.columnas,this.lista);
            }).catch(e=>{
                //alert(e);
            })
            this.$emit('spinner',false);
        },
        async cargar_url(url){
          
          if(url){
            this.$emit('spinner',true);
            this.pagina_actual = url;
            await this.axios.get(url,this.cabeceras_json).then((res)=>{
                this.lista = res.data.data.data;
                this.links = res.data.data.links;
                ////console.log('listado',res.data.data.data);
                this.setear_lista({lista:this.lista,links:this.links});
                //$('#empresas').DataTable().draw();
            }).catch(e=>{
                //alert(e);
            })
            this.$emit('spinner',false);
          }
          
        },
        async crear(){
            
          
          this.restablecer_inputs();
          this.$set(this.inputs[0],'valor',new Date().toISOString());
          this.setear_inputs(this.inputs);
          this.configuracion_modal.ruta = `/ingresos_petroleo`;
          this.configuracion_modal.tipo_ruta = 'post';
          this.configuracion_modal.titulo_boton = 'Crear';
          this.configuracion_modal.clase_boton = 'btn-success';

            this.$emit('abrir',{inputs:this.inputs});
        },
        editar(evento){
          //console.log('evento',evento);
          let item = evento.item;
          this.inputs.forEach(i => {
            //recorrido del objeto a editar
              Object.keys(item).forEach(key => {
                  let valor = item[key];
                  if(i.key == key){
                    if(i.tipo == 'datetimepicker'){
                      if(valor){
                        valor = new Date(valor).toISOString()
                      }
                    }
                      i.valor = valor;
                  }
              });
          });
          this.setear_inputs(this.inputs);
          this.configuracion_modal.ruta = `/ingresos_petroleo/${evento.item.id}`;
          this.configuracion_modal.tipo_ruta = 'put';
          this.configuracion_modal.titulo_boton = 'Actualizar';
          this.configuracion_modal.clase_boton = 'btn-warning';

          this.$emit('abrir');
        },
        restablecer_inputs(){
          this.cargar_url(this.pagina_actual);
          this.inputs.forEach(i => {
            i.valor = '';
          });
          this.setear_inputs(this.inputs);
        },
        ...mapActions(['inicializar_tabla','setear_lista','setear_inputs'])
    },
    components:{
        'modal-crear-editar':ModalCrearEditar,
        'tablita':Tabla
    },
    computed:{
        ...mapState(['api','cabeceras_json']),
        query(){
          let string = '?';
          let and = '';
          let total = this.columnas.length - 1;
          this.columnas.forEach((c,index) => {
            if(index > 0 && string.length>0){
              and = '&';
            }else if(index == total){
              and = '';
            }

            if(c.busqueda != ''){
              string += `${and}${c.key}=${c.busqueda}`;
            }
          });
          return string;
        },

        
    }
}
</script>
<style>
  .form-control{
    height: calc(1em + 1.25rem + 5px);
  }
</style>